export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const TRANSCRIPTION_LIST = '/transcripts';
export const NEW_TRANSCRIPT = '/new-transcript';
export const TRANSCRIPT_EDITOR = '/editor/:transcriptId';
export const transcriptEditorById = id => `/editor/${id}`;
